// retreive a unique identifier for column
export const getColumnName = (nodeId: string, dbName: string) =>
  `${nodeId}_${dbName}`
    .replace(/å|ä|Ä|Å/g, 'a')
    .replace(/ö|Ö/g, 'o')
    .replace(/[\W_]+/g, '_')
    .replace(/\s/g, '')
    .toLowerCase()

export const getNextColumnSuffix = (columns: { id: string }[]) => {
  // get numbers at end of string
  const columnNumbers = columns.map((col) =>
    Number(col.id.match(/\d+$/)?.[0] ?? NaN)
  )

  return columnNumbers.length ? Math.max(...columnNumbers) + 1 : 0
}
